/**
 * Matches polyfill.
 *
 * @param {any} el
 * @param {string} selectors
 */
export default function matches(el, selectors) {
    if (el == null) {
        return false;
    }

    const fn = el.matches || el.msMatchesSelector;

    if (!fn) {
        console.warn('The matches() method is not available in this browser. Returned false');
        return false;
    }

    return fn.call(el, selectors);
}
